
import axios from "axios";
import config from "@/config.json";

export function host() {
    return process.env.VUE_APP_SERVER_HOST;
}

export function webHost() {
    return process.env.VUE_APP_WEB_HOST;
}

export function avatarUrl() {
    return process.env.VUE_APP_AVATAR_URL;
}

export async function post(action, params) {

    try {
        /*
        const response = await  fetch(`${process.env.VUE_APP_SERVER_HOST}${action}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(params),
            mode:'cors',
            credentials: "include"
        });
        return response.json();
         */
        const headers = {
            'Accept': 'application/json',
        };
        const accessToken = localStorage.getItem("access_token");
        if (accessToken) {
            headers['Authorization'] = `Bearer ${accessToken}`;
        }
        const response = await axios.post(`${process.env.VUE_APP_SERVER_HOST}${action}`, params, { headers: headers });
        return response.data;
    } catch (e) {
        return null;
    }
}
